import "css/style.css"
import {lazyLoading} from "./lazyload/lazyload-init"
import "@components/main-header/main-header"
import "@components/forms/search-form/search-form"
import "@components/items/menu-item/menu-item"
import "js/cart-flow/cart-flow"
import {polyfill} from "smoothscroll-polyfill"
polyfill()

window.lazyloading = lazyLoading // add lazyloading to global window object

async function loadFancybox() {
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("./fancybox/fancybox")
  }
}
async function loadMain() {
  await import("./main")
  await import("./overlayscrollbars")
  loadFancybox()
}
loadMain()

async function loadModals() {
  if (document.querySelectorAll(".c-modal").length) {
    await import("@components/modal/modal")
  }
}
loadModals()

async function loadFileInput() {
  if (document.querySelectorAll(".f-file, .i-configuration").length) {
    await import("@components/fields/file-field/file-field")
  }
}
loadFileInput()

async function loadDateInput() {
  if (document.querySelectorAll(".f-date").length) {
    await import("@components/fields/date-field/date-field")
  }
}
loadDateInput()

async function loadPasswordField() {
  if (document.querySelectorAll(".f-text.--password").length) {
    await import("@components/fields/text-field/text-field--password")
  }
}
loadPasswordField()

async function loadCalendar() {
  if (document.querySelectorAll(".s-calendar").length) {
    await import("@components/sections/calendar-section/calendar-section")
  }
}
loadCalendar()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select, .i-configuration").length) {
    await import("./slim-select/slim-select")
  }
}
loadSlimSelect()

async function loadAlerts() {
  if (document.querySelectorAll(".i-alert").length) {
    await import("@components/items/alert-item/alert-item")
  }
}
loadAlerts()

async function loadNotification() {
  if (document.querySelectorAll(".i-notification").length) {
    await import("@components/items/notification-item/notification-item")
  }
}
loadNotification()

async function loadFaqItem() {
  if (document.querySelectorAll(".i-faq").length) {
    await import("@components/items/faq-item/faq-item")
  }
}
loadFaqItem()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("./swiper/swiper")
  }
}
loadSwiper()

async function loadCheckboxSelectField() {
  if (document.querySelectorAll(".f-checkbox-select").length) {
    await import("@components/fields/checkbox-select-field")
  }
}
loadCheckboxSelectField()

async function loadOverlayScrollbars() {
  if (document.querySelectorAll(".u-scrollbar").length) {
    await import("./overlayscrollbars")
  }
}
loadOverlayScrollbars()

async function loadBaseForm() {
  if (document.querySelectorAll("form.--validate").length) {
    await import("@components/base-form/base-form")
  }
}
loadBaseForm()

async function loadScrollUp() {
  if (document.querySelectorAll(".c-scroll-up").length) {
    await import("@components/scroll-up/scroll-up")
  }
}
loadScrollUp()

async function loadTextField() {
  if (document.querySelectorAll(".f-text, .f-textarea, .f-date, .i-configuration").length) {
    await import("@components/fields/text-field/text-field")
  }
}

loadTextField()

async function loadContentToggle() {
  if (document.querySelectorAll(".u-js-toggle__content").length) {
    await import("./toggle/toggle")
  }
}

loadContentToggle()

async function contentToggleItem() {
  if (document.querySelectorAll(".i-content-toggle, .i-configuration").length) {
    await import("@components/items/content-toggle-item/content-toggle-item")
  }
}

contentToggleItem()

async function userButtonItem() {
  if (document.querySelectorAll(".i-user-button").length) {
    await import("@components/items/user-button-item/user-button-item")
  }
}

userButtonItem()

async function loadCounter() {
  if (document.querySelectorAll(".c-counter, .i-configuration").length) {
    await import("@components/counter/counter")
  }
}

loadCounter()

async function loadProductItem() {
  if (document.querySelectorAll(".i-product").length) {
    await import("@components/items/product-item/product-item")
  }
}

loadProductItem()

async function basePerex() {
  if (document.querySelectorAll(".base-perex").length) {
    await import("@components/base-perex/base-perex")
  }
}

basePerex()

async function cartOverview() {
  if (document.querySelectorAll(".w-cart-overview").length) {
    await import("@components/widgets/cart-overview-widget/cart-overview-widget")
  }
}
cartOverview()

async function loadTippy() {
  if (document.querySelectorAll(".i-tooltip, .i-configuration").length) {
    await import("./tippy")
  }
}
loadTippy()

async function loadAddressBox() {
  if (document.querySelectorAll(".f-address-box__tooltip").length) {
    await import("@components/fields/address-box-field/address-box-field")
  }
}
loadAddressBox()

async function loadIcoField() {
  if (document.querySelectorAll(".f-ico").length) {
    await import("@components/fields/ico-field/ico-field")
  }
}
loadIcoField()

async function loadRangeSlider() {
  if (document.querySelectorAll(".f-range-slider, .i-configuration").length) {
    await import("@components/fields/range-slider-field/range-slider-field")
  }
}
loadRangeSlider()

async function loadIndividualPrintForm() {
  if (document.querySelectorAll(".f-individual-print--toggle-content, .i-configuration").length) {
    await import("@components/forms/individual-print-form/f-individual-print--toggle-content")
  }
}
loadIndividualPrintForm()

async function loadCopyField() {
  if (document.querySelectorAll(".f-text.--copy").length) {
    await import("@components/fields/text-field/text-field--copy")
  }
}
loadCopyField()

async function loadPricelistController() {
  if (document.querySelectorAll(".--js-pricelist-controler, .i-configuration").length) {
    await import("js/pricelist-controller/pricelist-controller")
  }
}
loadPricelistController()

async function loadPricelist() {
  if (document.querySelectorAll(".i-pricelist").length) {
    await import("@components/items/pricelist-item/pricelist-item")
  }
}
loadPricelist()

async function loadPrintDemandForm() {
  if (document.querySelectorAll(".f-demand-print").length) {
    await import("@components/forms/print-demand-form/print-demand-form")
  }
}
loadPrintDemandForm()

async function loadMulticheckbox() {
  if (document.querySelectorAll(".f-multicheckbox--toggleable").length) {
    await import("@components/fields/multicheckbox-field/multicheckbox-field")
  }
}
loadMulticheckbox()

async function loadProductDetail() {
  if (document.querySelectorAll(".c-product-detail").length) {
    await import("@components/product-detail/product-detail/product-detail")
  }
}
loadProductDetail()

async function loadFilter() {
  if (document.querySelectorAll(".js-filter-list").length) {
    await import("@components/sections/filters-section/filters-section")
  }
}

async function loadFilterDimensions() {
  if (document.querySelectorAll(".i-filtration__dimensions").length) {
    await import("@components/items/filtration-item/filtration-item--dimensions")
  }
}
loadFilterDimensions().then(loadFilter)

async function loadInfiniteTestimonials() {
  if (document.querySelectorAll(".g-testimonials.--infinite").length) {
    await import("@components/groups/testimonials-group/testimonials-group--infinite")
  }
}
loadInfiniteTestimonials()

async function loadPrintInfoItem() {
  if (document.querySelectorAll(".i-print-item.--js-toggle-fieldset").length) {
    await import("@components/items/print-variant-item/print-variant-item")
  }
}
loadPrintInfoItem()

async function loadPrintConfigFieldset() {
  if (document.querySelectorAll(".f-print-configuration__fieldset, .i-configuration").length) {
    await import("@components/fields/print-configuration-fieldset/print-configuration-fieldset")
  }
}
loadPrintConfigFieldset()

async function loadComparators() {
  if (document.querySelectorAll(".i-comparator").length) {
    await import("@components/items/comparator-item/comparator-item")
  }
}
loadComparators()

async function loadComparatorEditNameModal() {
  if (document.querySelectorAll(".m-edit-comparator-name").length) {
    await import("@components/modals/edit-comparator-name-modal/edit-comparator-name-modal")
  }
}
loadComparatorEditNameModal()

async function loadTabs() {
  if (document.querySelectorAll(".--js-tabs").length) {
    await import("@components/tabs/tabs")
  }
}
loadTabs()

async function loadComparatorContent() {
  if (document.querySelectorAll(".i-comparator__tabs-content").length) {
    await import("@components/groups/comparator-content-group/comparator-content-group")
  }
}
loadComparatorContent()

async function loadComparatorSlider() {
  if (document.querySelectorAll(".g-comparator-slider").length) {
    await import("@components/groups/comparator-content-slider-group/comparator-content-slider-group")
  }
}
loadComparatorSlider()

async function loadPrintConfigForm() {
  if (document.querySelectorAll(".f-print-configuration, .i-configuration").length) {
    await import("@components/forms/print-configuration-form/print-configuration-form")
  }
}
loadPrintConfigForm()

async function loadConfigurationItem() {
  if (document.querySelectorAll(".i-configuration").length) {
    await import("@components/items/configuration-item/configuration-item")
  }
}
loadConfigurationItem()
